import { HotjarScript } from '@avanta/shared/components/HotjarScript';
import { LoadingScreen } from '@avanta/shared/components/LoadingScreen';
import { DialogProvider } from '@avanta/shared/contexts/Dialog';
import { TooltipProvider } from '@avanta/shared/contexts/Tooltip';
import { initSentry, Sentry } from '@avanta/shared/sentry';
import { StrictMode, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { Toaster } from 'sonner';
import { MobileBlockedView } from 'components/MobileBlockedView';
import { QueryClientProvider } from './query-manager.tsx';
import { AppRouter } from './routes/index.tsx';
import '@avanta/shared/i18n';
import '@avanta/shared/index.css';

initSentry();
const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Failed to find the root element');

// eslint-disable-next-line no-console
console.info(`📦 avanta-enterprise | v${__APP_VERSION__}`);

createRoot(rootElement).render(
  <StrictMode>
    <Sentry.ErrorBoundary>
      <HotjarScript />
      <Suspense fallback={<LoadingScreen />}>
        <QueryClientProvider>
          <DialogProvider>
            <TooltipProvider>
              <Toaster expand richColors visibleToasts={3} className="max-am-sm:w-60" />
              <MobileBlockedView />
              <div className="max-am-lg:hidden">
                <AppRouter />
              </div>
            </TooltipProvider>
          </DialogProvider>
        </QueryClientProvider>
      </Suspense>
    </Sentry.ErrorBoundary>
  </StrictMode>
);
